module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#gallery",
      toString: function () {
        return this.url;
      }
    }